export const TECHNICAL_SKILLS = [
  'TypeScript',
  'JavaScript (ES6+)',
  'HTML5, CSS3',
  'React',
  'Next.js',
  'Redux',
  'Context API',
  'React Hooks / Custom Hooks',
  'SPA',
  'App Router',
  'Server Components',
  'GraphQL (Apollo)',
  'REST API',
  'WebSockets, Mercure',
  'Chart.js',
  'Material UI',
  'Styled Components',
  'Emotion, Tailwind CSS',
  'React Hook Form',
  'Performance Optimization',
  'Responsive Web Design',
  'Git, GitHub',
  'Webpack',
  'GitHub Copilot',
  'AI-assisted workflows',
  'Code Reviews',
  'ClickUp, Slack, Miro, Figma',
];

export const SOFT_SKILLS = [
  'Ownership mindset',
  'System thinking',
  'Proactive communication',
  'Mentoring and onboarding',
  'Problem-solving',
  'Team player',
  'Motivated',
  'Scrum',
  'Agile',
];

export const LANGUAGES = [
  'Polish - C1',
  'English - B2',
  'Ukrainian - Native',
  'Russian - C2',
];

export const EDUCATION_EXPERIENCE = [
  {
    subtitle: 'European University',
    date: '(2006 - 2011)',
    skills: ['Finance'],
  },
  {
    subtitle: 'IT School "GoIT"',
    date: '(January 2021 - January 2022)',
    skills: ['Full Stack Developer (JS, React.js, Node.js, HTML, CSS)'],
  },
  {
    subtitle: 'Policealna Szkoła Zawodowa "Eduatut"',
    date: '(2018 - 2020)',
    skills: ['IT Specialist'],
  },
];

export const OTHER_EDUCATION_EXPERIENCE = [
  {
    subtitle: 'English School "Study-Less"',
    date: '(August 2021 - June 2022)',
    skills: ['Upper-Intermediate (B2)'],
  },
  {
    subtitle: '"Academy of language"',
    date: '(2019 - 2020)',
    skills: ['English language course'],
  },
  {
    subtitle: 'Course "Graphic designer"',
    date: '(2019)',
    skills: ['Photoshop, CorelDRAW'],
  },
];

export const WORK_EXPERIENCE = [
  {
    subtitle: '"Digital Creative Cluster" | "Learning-Space Sp. z o.o."',
    role: 'Frontend React Developer',
    date: '(June 2022 - July 2026)',
    skills: [
      'Grew from junior to mid-level, taking ownership of full-page features, architectural decisions, and cross-cutting platform changes.',
      'Contributed approximately 50% of platform frontend functionality across a large-scale EdTech SPA used by thousands of users.',
      'Designed a reusable data table ecosystem with filtering, sorting, search, and infinite-scroll pagination integrated with server-side queries.',
      'Replaced 4 legacy table implementations and established the new approach as an internal standard with additional migrations planned.',
      'Conceived and built a contextual onboarding assistant with progress-based hints and localStorage history to avoid redundant suggestions.',
      'Built analytics dashboards with Chart.js visualizations, collapsible metric cards, drag-and-drop widgets, and backend-powered filters.',
      'Engineered a content reuse system for lessons, exams, events, and content blocks across courses, reducing content creation time by 4x.',
      'Optimized GraphQL queries on key platform pages, reducing backend request load and improving page performance.',
      'Delivered subscription management and payment dashboards with multi-step course and payment flow generators for free and paid tiers.',
      'Implemented auth redirect flows that return unauthenticated users to intended destinations after login, including cross-space navigation.',
      'Built a global runtime error handler to prevent platform crashes and surface contextual error dialogs.',
      'Configured custom Webpack setup and frontend-side image storage, removing dependency on paid third-party asset services.',
      'Led progressive JSX to TSX migration to improve type safety and long-term maintainability.',
      'Added support for 4 languages (PL, EN, ES, IT) with a dynamic language switcher and AI-assisted translation workflow.',
      'Integrated WebSockets (Mercure) for real-time notifications and live platform activity.',
      'Used GitHub Copilot and LLM tools to accelerate refactoring and routine implementation, improving personal delivery velocity by 20-30%.',
      'Conducted onboarding sessions for new developers, performed regular code reviews, and contributed to frontend architecture decisions.',
    ],
  },
  {
    subtitle: 'Personal Projects',
    date: '(Jul 2020 - Present)',
    role: 'Frontend Developer (React / Next.js)',
    skills: [
      'Actively develop personal projects using Next.js 14/15 (App Router, Server Components), exploring SSR, SEO optimization, and modern React patterns including AI integrations.',
    ],
  },
];

export const OTHER_WORK_EXPERIENCE = [
  {
    subtitle: 'Faurecia | Forvia',
    date: '(2018 - 2022)',
    role: 'Operator',
    skills: [
      'I consistently met production targets and maintained high standards of quality and efficiency, resulting in a 20% decrease in the number of complaints.',
      'Contributed to process improvements that increased output and resulted in a 10-20% decrease in defective products.',
      'Collaborated effectively with team members to ensure smooth operations and adherence to safety protocols.',
    ],
  },
];
